import { combineReducers } from "redux";

const songsReducer = () => {
    return [
        {title : 'No Scrubs', duration: '4:05'},
        {title : 'Macarena', duration: '5:30'},
        {title : 'All Star', duration: '3:15'},
        {title : 'Wannabe', duration: '3:00'},
    ];
};

const selectedSongReducer = (selectedSong=null, action) => {
    if(action.type === 'SONG_SELECTED'){
        return action.payload;
    }

    return selectedSong;
};

export default combineReducers({
    songs: songsReducer,
    selectedSong: selectedSongReducer
});